import { Loader } from '@googlemaps/js-api-loader';

export const loadGoogleMaps = (lng: string) => {
    const loader = new Loader({
        apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
        libraries: ['places'],
        language: lng === 'fr' ? 'fr-BE' : 'nl-BE',
        region: 'BE',
    });

    return loader.importLibrary('maps');
};
